import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import "@/authClient";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Varieties from "@/components/Varieties";
import Origin from "@/components/Origin";
import Bento from "@/components/Bento";
import Process from "@/components/Process";
import Journal from "@/components/Journal";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import AdminPage from "@/components/AdminPage";
import ChatWidget from "@/components/ChatWidget";
import MaintenancePage from "@/components/MaintenancePage";
import { fetchSettings } from "@/siteSettings";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothTouch: true,
      anchors: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream text-bark antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Varieties />
        <Origin />
        <Bento />
        <Process />
        <Journal />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  const [site, setSite] = useState(null);
  useEffect(() => {
    fetchSettings().then(setSite);
  }, []);
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (site === null) {
    return <div className="min-h-screen bg-cream" data-testid="site-loading" />;
  }
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={site.maintenance_mode ? <MaintenancePage site={site} /> : <Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#FFFDF7",
              border: "1px solid rgba(176,104,44,0.35)",
              color: "#3A2B1A",
            },
          }}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}
